import React from 'react';
import { Section } from '../ui/Section';
import { XCircle, CheckCircle2 } from 'lucide-react';
export function Comparison() {
  const rows = [{
    bad: 'Horas buscando info de pacientes',
    good: 'Sistema que controla todo en minutos'
  }, {
    bad: 'Pacientes que abandonan sin que te enteres',
    good: 'Alertas de control vencido'
  }, {
    bad: 'Trámites sin seguimiento, demoras eternas',
    good: 'Semáforo de autorizaciones en curso'
  }, {
    bad: 'Informes armados de cero cada vez',
    good: 'Plantillas listas para junta médica'
  }, {
    bad: 'No sabés cuánto te debe cada prestador',
    good: 'Tablero financiero claro y mensual'
  }, {
    bad: 'Sin indicadores de tu consultorio',
    good: 'Dashboard de gestión integrado'
  }, {
    bad: 'Burnout detectado tarde',
    good: 'Sistema de alerta temprana'
  }, {
    bad: 'Paciente nuevo desorganizado',
    good: 'Protocolo de bienvenida estructurado'
  }];
  return <Section className="bg-slate-50" data-id="element-42">
      <div className="container mx-auto px-4 max-w-5xl" data-id="element-43">
        <div className="text-center mb-8 md:mb-16" data-id="element-44">
          <h2 className="text-xs md:text-sm font-bold text-teal-600 tracking-widest uppercase mb-1 md:mb-2" data-id="element-45">
            La Realidad
          </h2>
          <h3 className="text-2xl md:text-4xl font-bold text-slate-900 mb-2 md:mb-4" data-id="element-46">
            ¿Cuánto te cuesta NO tener un sistema?
          </h3>
        </div>

        <div className="bg-white rounded-2xl md:rounded-3xl shadow-xl overflow-hidden border border-slate-200" data-id="element-47">
          <div className="grid grid-cols-2 bg-slate-900 text-white p-4 md:p-6 text-center font-bold text-base md:text-xl" data-id="element-48">
            <div className="border-r border-slate-700" data-id="element-49">Sin el sistema</div>
            <div className="text-teal-400" data-id="element-50">Con el sistema</div>
          </div>

          <div className="divide-y divide-slate-100" data-id="element-51">
            {rows.map((row, i) => <div key={i} className="grid grid-cols-2 p-3 md:p-6 items-center hover:bg-slate-50 transition-colors group" data-id="element-52">
                <div className="flex items-start gap-2 md:gap-3 pr-2 md:pr-4 border-r border-slate-100" data-id="element-53">
                  <XCircle className="h-4 w-4 md:h-5 md:w-5 text-red-400 flex-shrink-0 mt-0.5 group-hover:scale-110 transition-transform" data-id="element-54" />
                  <span className="text-slate-600 text-xs md:text-base" data-id="element-55">
                    {row.bad}
                  </span>
                </div>
                <div className="flex items-start gap-2 md:gap-3 pl-2 md:pl-6" data-id="element-56">
                  <CheckCircle2 className="h-4 w-4 md:h-5 md:w-5 text-teal-500 flex-shrink-0 mt-0.5 group-hover:scale-110 transition-transform" data-id="element-57" />
                  <span className="text-slate-900 font-semibold text-xs md:text-base" data-id="element-58">
                    {row.good}
                  </span>
                </div>
              </div>)}
          </div>
        </div>

        <div className="mt-8 md:mt-12 text-center max-w-2xl mx-auto" data-id="element-59">
          <p className="text-lg md:text-xl text-slate-700 font-medium px-4" data-id="element-60">
            Implementá el sistema completo en 7 días y recuperá horas de gestión
            cada semana.
          </p>
        </div>
      </div>
    </Section>;
}